export const TEST_EVENT_NAME = "test_event:client";
export const VIEW_CONTENT_EVENT_NAME = "view_content:client";

// Button and Link clicks
export const BUTTON_CLICK_EVENT = "button_click:client";
export const LINK_CLICK_EVENT = "link_click:client";

// Form events
export const FORM_FIELD_CHANGE_EVENT = "form_field_change:client";
export const FORM_SUBMIT_EVENT = "form_submit:client";
export const AUTOCOMPLETE_SELECT_EVENT = "autocomplete_select:client";

// Integration specific events
export const INTEGRATION_SUCCESS_VIEW_EVENT = "integration_success_view:client";
export const ORDER_REPORT_VIEW_EVENT = "order_report_view:client";
export const ORDER_REVIEW_EVENT = "order_review:client";
export const ORDER_CANCEL_EVENT = "order_cancel:client";
export const ORDER_SUCCESS_EVENT = "order_success:client";
export const ORDER_FAILURE_EVENT = "order_failure:client";

// Navigation events
export const NAVIGATE_TO_EAGLEVIEW_EVENT = "navigate_to_eagleview:client";
export const NAVIGATE_BACK_TO_JOBBER_EVENT = "navigate_back_to_jobber:client";
export const RETURN_TO_JOBBER_EVENT = "return_to_jobber:client";
export const NAVIGATE_TO_EAGLEVIEW_BILLING_EVENT =
  "navigate_to_eagleview_billing:client";
